export default __webpack_public_path__ + "static/media/25w.8cfea078.svg";